const ActionCable = require('actioncable')

function loadActionCable() {
  if (typeof window === 'undefined') {
    return
  }

  window.App = window.App || {}
  if (!window.App.cable?.subscriptions) {
    window.App.cable = ActionCable.createConsumer()
  }
}

loadActionCable()

window.addEventListener("load", () => {
  loadActionCable()

  const ReactRailsUJS = require("react_ujs");
  const context = require.context(
    'Pods',
    true,
    /\/ThreeDStudio\/(?!.*\.test.*$).*$/
  )

  ReactRailsUJS.useContext(context);
  ReactRailsUJS.mountComponents("#three-d-studio-elements");
});
